<!--<h3>{{ 'dataTransformations.searchTransformations' | translate }}</h3>-->
<div class="row fields-group">
    <div class="col">
        <label for="search-transformation-field" class="d-block list-title">{{ "Format input" | translate }}</label>
        <select id="search-transformation-field" class="d-flex w-100 form-control" [(ngModel)]="typeTransformation" (change)="typeUpdate()">
            <option value="">{{'Select' | translate}}</option>
            <!--<option value="trimData">{{'Trim data' | translate}}</option>-->
            <option value="removeSpaces">{{'Remove spaces' | translate}}</option>
        </select>
    </div>
</div>
